<br>

<div style="width: auto; overflow: auto">
  <app-common-list-table
          [request]="getRequest"
          [cols]="cols"
          [globalConditionalStyle]="globalConditionalStyle"
          [globalVisualTransform]="globalVisualTransform"
          [filtering]="filter"
          [actionButtonText]="btnAnadir"
          (actionButtonClick)="add()"
          (emitSearchText)="updateFooter()">

          <ng-template #header>
            <div style="display: flex;">
              <div style="margin-left: 20px;">
                <button class="mx-2 btn btn-info" (click)="downloadCsv()" style="padding: 5px; font-size: .8rem;">
                    <i class="fa fa-download"></i>
                    Exportar listado
                </button>
              </div>
            </div>
            </ng-template>
    <ng-template #thEnd>
      <th>
        <p class="d-flex justify-content-center"
           style="margin-bottom: 0">Acciones</p>
      </th>
    </ng-template>

        <ng-template #tdEnd let-data let-isFirstRow="isFirstRow">
            <td>
                <app-action-buttons
                    [tourAnchorId]="isFirstRow ? 'farmerTour.rowActions' : ''"
                [hideEdit]="this.appName === 'salf' && esUsuario"
                [showDuplicate]="true"
                (duplicateRowButtonEvent)="duplicate(data.data)"       
                (editRowButtonEvent)="edit(data.data)"
                (deleteRowButtonEvent)="show('delete', data.data)"
                (showRowButtonEvent)="show('info', data.data)">
        </app-action-buttons>
      </td>
    </ng-template>

    <ng-template #footer let-col>
        <div style="font-size: 0.75em; text-align: left" *ngIf="(['finca'].includes(col.field))">
            TOTAL:
        </div>
        <div style="font-size: 0.75em; text-align: right; font-weight: bold; padding-right: 34px" *ngIf="(['cantidad'].includes(col.field))">
            {{col.footer}}
        </div>
    </ng-template>
  </app-common-list-table>
</div>


<app-modals
    [view]="this"
    [form]="form?.formFields"
    [serverUrl]="serverUrl"
    [previousData]="model"
    [recordHasAssociatedData]="false"
    [getRequest]="getRequest"
    [deleteRequest]="deleteRequest">
</app-modals>

